import { formatDate } from "@progress/kendo-intl";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import { LoadingIndicator } from "../../../core/loading-indicator.component";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import {  ExcelExport,  ExcelExportColumn,} from "@progress/kendo-react-excel-export";
import ZoneRoutewiseAbstractModel from "../../../models/reports/zoneroutewiseabstract-reports";
import { getDataWithToken, getEndPoint } from "../../../Utils/network.client";
import { API_END_POINT } from "../../../constants";
import axios from "axios";
import { PDFExport } from "@progress/kendo-react-pdf";
import { useGetCompanyDetails } from "../../../apiclient/master/useGetCompanydetailsApi";

interface IZoneRoutewiseAbstractReport {}

export const ZoneRoutewiseAbstractReport: React.FC = () => {
  const [reportMenu, setReportMenu] = useState<IZoneRoutewiseAbstractReport[]>([]);
  const [fromDate, setFromDate] = useState<Date>(new Date(dayjs().add(0, "months").format("MM/DD/YYYY")));
  const [toDate, setToDate] = useState<Date>(new Date());

  const exportExcel = useRef<ExcelExport | null>(null);
  const pdfExportRef = useRef<PDFExport | null>(null);

  const { data: companyDetails, isLoading: isCompanyLoading } =
  useGetCompanyDetails();
const companyName = companyDetails?.[0]?.companyName || "Company Name";


  const [zoneRoutewiseAbstractList, setZoneRoutewiseAbstractList] = useState<ZoneRoutewiseAbstractModel[]>([]);
  const [loading, setLoading] = useState<boolean>(false); 

  const [fromDate2, setFromDate2] = useState<string>(
    ""
  );


  useEffect(() => {}, [reportMenu]);

  const exportToExcel = () => {
    if (!exportExcel.current) return;
  
    const options = exportExcel.current.workbookOptions();
    const sheet = options.sheets[0];
  
    const formattedDate = fromDate
      ? new Date(fromDate).toLocaleDateString("en-IN", {
          day: "numeric",
          month: "numeric",
          year: "numeric",
        })
      : "";
  
    const headingWithDate = `Zone Routewise Abstract - ${formattedDate}`;
  
    // Add a single merged heading row with the full string
    sheet.rows.unshift({
      cells: [
        {
          value: headingWithDate,
          colSpan: sheet.columns.length,
          bold: true,
          fontSize: 14,
          textAlign: "center",
        },
      ],
    });
    sheet.rows.unshift({
      cells: [
        {
          value: companyName,
          colSpan: sheet.columns.length,
          bold: true,
          fontSize: 14,
          textAlign: "center",
         
        },
      ],
    });
  
    exportExcel.current.save(options);
  };
  const exportToPDF = () => {
    if (pdfExportRef.current) {
      pdfExportRef.current.save();
    }
  };

  const getOrderHistoryList = async () => {
    if (!fromDate || !toDate) {
      alert("Please select both From Date and To Date.");
      return;
    }

    try {
      setLoading(true); // Start loading before the API call

      const getZoneAbstractUrl = `${getEndPoint(API_END_POINT.REPORT)}/api/DailyReportsService/GetZoneRoutewiseAbstract/${fromDate2}`;

      // const getZoneRoutewiseAbstractListUrl =
      //   getEndPoint(API_END_POINT.REPORT) + "/api/DailyReportsService/GetZoneRoutewiseAbstract;

        const response = await getDataWithToken<any>(
          getZoneAbstractUrl
                                                      );

      // const response = await axios.get(getZoneRoutewiseAbstractListUrl, {
      //   params: {
      //     ifDate: fromDate,
      //   },
      // });

      const zoneRoutewiseAbstractList = response?.data?.result || [];
      console.log("a",zoneRoutewiseAbstractList)
      setZoneRoutewiseAbstractList(zoneRoutewiseAbstractList); // Update state with fetched data
      setLoading(false); // Stop loading when data is received
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false); // Stop loading if there's an error
    }
  };

  useEffect(() => {
      if (fromDate) {
        const formattedDate2 = dayjs(fromDate).format('ddd MMM DD YYYY HH:mm:ss');
        console.log("Formatted Date:", formattedDate2);
        setFromDate2(formattedDate2);
      }
    }, [fromDate]);

    const handleDateChange = (value: any) => {
      // const today = new Date();
      const day = value.getDate().toString().padStart(2, '0');
      const month = value.toLocaleString('default', { month: 'short' }).toUpperCase(); // Get short month (e.g., JAN)
      const year = value.getFullYear();
  
      const formattedDate = new Date(`${year}-${month}-${day}`);
  
      setFromDate(formattedDate);
  
      // const formattedDate2 = dayjs(value).format('ddd MMM DD YYYY HH:mm:ss');
      // console.log(formattedDate2);
      // setFromDate2(formattedDate2);
    };
    const hasRecords = zoneRoutewiseAbstractList.length > 0; 

  let grid = null;
    grid = (
    <Grid
      data={zoneRoutewiseAbstractList}
      // pageable={{ pageSizes: [10, 20, 50, 100] }}
      total={null}
      groupable={false}
      sortable={true}
      onDataStateChange={null}
      onExpandChange={null}
      expandField="expanded"
      columnVirtualization={false}
      resizable={true}
    >
      <GridColumn
        field="zName"
        title="Zone"
        columnMenu={null}
      />
      <GridColumn
        field="rName"
        title="Route"
        columnMenu={null}
      />
      <GridColumn
        field="morningLiters"
        title="Morning Liters"
        columnMenu={null}
        cell={(props) => (
          <td style={{ textAlign: 'right' }}>{props.dataItem.morningLiters?.toFixed(2)}</td>
        )}
        footerCell={(props) => {
          const totalMorningLiters = zoneRoutewiseAbstractList.reduce(
            (acc, item) => acc + (item.morningLiters || 0),
            0
          );
          return (
            <td colSpan={props.colSpan} style={{ textAlign: 'right' }}>
              {totalMorningLiters.toFixed(2)}
            </td>
          );
        }}
      />

      <GridColumn
        field="eveningLiters"
        title="Evening Liters"
        columnMenu={null}
        cell={(props) => (
          <td style={{ textAlign: 'right' }}>{props.dataItem.eveningLiters?.toFixed(2)}</td>
        )}
        footerCell={(props) => {
          const totalEveningLiters = zoneRoutewiseAbstractList.reduce(
            (acc, item) => acc + (item.eveningLiters || 0),
            0
          );
          return (
            <td colSpan={props.colSpan} style={{ textAlign: 'right' }}>
              {totalEveningLiters.toFixed(2)}
            </td>
          );
        }}
      />
      <GridColumn 
      field="totalLiters" 
      title="Total Liters" 
      
      cell={(props) => (
        <td style={{ textAlign: 'right' }}>{props.dataItem.morningLiters?.toFixed(2)}</td>
      )}
      footerCell={(props) => {
        const totalTotalLiters = zoneRoutewiseAbstractList.reduce(
          (acc, item) => acc + (item.totalLiters || 0),
          0
        );
        return (
          <td colSpan={props.colSpan} style={{ textAlign: 'right' }}>
            {totalTotalLiters.toFixed(2)}
          </td>
        );
      }}
      />

      <GridNoRecords>
        <div className="mt-2" style={{ height: "500px" }}>
          <center>
            <h5>No data found</h5>
          </center>
        </div>
      </GridNoRecords>
    </Grid>
  );
  return (
    <>
      <div
        className="m-lg-3 mt-lg-1 m-4 card p-3 border-0 m-3 sw-shadow radius-15"
        style={{ minHeight: "500px" }}
      >
        <div className="top-sec-align row">
            <center>
          <h4 className="text-normal title-web mb-0 report-title-color">Zone Routewise Abstract </h4>
          </center>
        </div>
        <div className="fade_rule"></div>
        <div className="d-flex justify-content-between mt-4 pt-3 pb-3">
          {/* <div>
            <label>Search</label>
            <input
              type="text"
              className="form-control ms-auto search-right-align searchBg"
            />
          </div> */}
          <div className="d-flex">
            <div className="me-2">
              <label>Select Date</label>
              <DatePicker
                selectsMultiple={true}
                openToDate={new Date()}
                className="form-control ms-auto search-right-align calendarBg"
                value={formatDate(fromDate, "dd/MM/yyyy")}
                placeholderText="To"
                dateFormat={"dd/MM/yyyy"}
                onChange={([date]: any) => {
                  // setFromDate(date);
                  handleDateChange(date)
                }}
              />
            </div>
            
            <div>
              <label></label>
              <button
                className="btn-primary btn search-btns mt-4"
                onClick={() => {
                 getOrderHistoryList();
                }}
                type="submit"
              >
                <svg width="17" height="17" viewBox="0 0 17.5 17.5">
                  <path
                    id="Path_magnify"
                    data-name="Path / magnify"
                    d="M9.5,3a6.5,6.5,0,0,1,4.94,10.73l.27.27h.79l5,5L19,20.5l-5-5v-.79l-.27-.27A6.5,6.5,0,1,1,9.5,3m0,2A4.5,4.5,0,1,0,14,9.5,4.481,4.481,0,0,0,9.5,5Z"
                    transform="translate(-3 -3)"
                    fill="#fff"
                  />
                </svg>
              </button>
              </div>
              <div className="d-flex justify-content-end">
                  <button
                    title="Export Excel"
                    className="export-button ms-2"
                    onClick={exportToExcel}
                    disabled={!hasRecords}
                    style={{ marginTop: "25px" }}
                  >
                    Export to Excel
                  </button>
                  <button
                    title="Export Excel"
                    className="export-button ms-2"
                    onClick={exportToPDF}
                    disabled={!hasRecords}
                    style={{ marginTop: "25px" }}
                  >
                    Export to PDF
                  </button>

                </div>
          </div>
        </div>
        <div className="row col=12">
          <div>
            {/* <button title="Export Excel" className="btn m-2" onClick={null}>
                  Export to Excel
                </button> */}
                {/* <button
                  title="Refresh list"
                  className="btn two m-2"
                  onClick={() => {}}
                >
                  Refresh
                </button> */}
              
            <LoadingIndicator isLoading={false} />
           
            <PDFExport
                       fileName={"Zone_Routewise_Abstract.pdf"}
                       ref={pdfExportRef}
                      title="Zone Routewise Abstract"              
                        > 
            <div style={{ padding: "10px", backgroundColor: "#fff" }}>
              {/* Company Name */}
              <div style={{ textAlign: "center", marginBottom: "5px" }}>
                <span style={{ fontWeight: "bold", fontSize: "1.5rem" }}>
                  {companyDetails?.[0]?.companyName || "Company Name"}
                </span>
              </div>
                <div style={{ textAlign: "center", marginBottom: "10px" }}>
  <span style={{ fontWeight: "bold", fontSize: "1.25rem" }}>
  Zone Routewise Abstract Report
    {fromDate && (
      <>
        {" - "}
        {new Date(fromDate).toLocaleDateString("en-IN", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
        })}
      </>
    )}
  </span>
</div>

            {grid}
            </div>
              <ExcelExport
                  fileName={"zoneRoutewiseAbstract_List"}
                  data={zoneRoutewiseAbstractList}
                  ref={exportExcel}
                >
                  <ExcelExportColumn
                    width={100}
                    field="zName"
                    title="Zone"
                  />          
                    <ExcelExportColumn
                    width={100}
                    field="rName"
                    title="Route"
                  />
                  <ExcelExportColumn
                    width={100}
                    field="morningLiters"
                    title="Morning Liters"
                    footer={() => {
                      const totalMorningLiters = zoneRoutewiseAbstractList.reduce(
                        (acc, item) => acc + (item.morningLiters || 0),
                        0
                      );
                      return totalMorningLiters.toFixed(2);
                    }}
                  />          
                    <ExcelExportColumn
                    width={100}
                    field="eveningLiters"
                    title="Evening Liters"
                    footer={() => {
                      const totalEveningLiters = zoneRoutewiseAbstractList.reduce(
                        (acc, item) => acc + (item.eveningLiters || 0),
                        0
                      );
                      return totalEveningLiters.toFixed(2);
                    }}
                  />
                  <ExcelExportColumn
                    width={100}
                    field="totalLiters"
                    title="Total Liters"
                    footer={() => {
                      const totalTotalLiters = zoneRoutewiseAbstractList.reduce(
                        (acc, item) => acc + (item.totalLiters || 0),
                        0
                      );
                      return totalTotalLiters.toFixed(2);
                    }}
                  />        
                  
                  
                </ExcelExport>
                </PDFExport>

                </div>
          </div>
        </div>
    </>
  );
};
